
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1595829608228",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4042",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M202.24 61.44h619.52c48.64 0 88.746667 40.106667 88.746667 88.746667v707.413333c0 48.64-40.106667 88.746667-88.746667 88.746667H202.24c-48.64 0-88.746667-40.106667-88.746667-88.746667v-708.266667c0.853333-48.64 40.106667-87.893333 88.746667-87.893333z m88.746667 198.826667v88.746666h447.146666V260.266667H290.986667z m0 175.786666v88.746667h447.146666V436.053333H290.986667z m0 178.346667v88.746667h334.506666V614.4H290.986667z",
        "p-id": "4043"
      }
    }
  ]
})
    }
  